import React from 'react'

import BusinessShareIcon from '~/components/common/icons/BusinessShareIcon'
import type { Prescription } from '~/types'

import styles from './PrescriptionNameCell.module.scss'

interface PrescriptionNameCellProps {
  prescription: Prescription
}

const PrescriptionNameCell = ({ prescription }: PrescriptionNameCellProps) => (
  <div className={styles.container}>
    <span className={styles.name} title={prescription.name}>
      {prescription.name}
    </span>
    <BusinessShareIcon
      businessIds={prescription.businessId ? [prescription.businessId] : []}
      color="black"
    />
  </div>
)

export default PrescriptionNameCell
